import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: BASE,
  withCredentials: false,
});

const TOKEN_KEY = "amadi_admin_token";

export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a public image URL for a stored file id.
export const imageUrl = (fileId) =>
  fileId ? `${BASE}/api/insights/image/${fileId}` : null;

export const videoUrl = (fileId) =>
  fileId ? `${BASE}/api/insights/video/${fileId}` : null;

export const fileUrl = (fileId) =>
  fileId ? `${BASE}/api/insights/file/${fileId}` : null;

// Chunked upload for video files (bypasses proxy body-size limits).
export async function uploadVideoChunked(file, onProgress) {
  const CHUNK = 5 * 1024 * 1024;
  const initFd = new FormData();
  initFd.append("filename", file.name);
  const { data: initData } = await api.post("/api/admin/upload-video/init", initFd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const uploadId = initData.upload_id;
  const total = Math.ceil(file.size / CHUNK) || 1;
  for (let i = 0; i < total; i++) {
    const chunk = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("file", chunk, file.name);
    await api.post("/api/admin/upload-video/chunk", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  const doneFd = new FormData();
  doneFd.append("upload_id", uploadId);
  doneFd.append("filename", file.name);
  const { data } = await api.post("/api/admin/upload-video/complete", doneFd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { file_id, url }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
